import {
  parameterStatusUtils
} from '../types/ParameterData';

export type ParameterRange = {
  min: number;
  max: number;
};

export const ParameterStatusBadge: React.FC<{
  value: number;
  range: ParameterRange;
  isSingleStatus?: boolean;
  date: string;
}> = ({ value, range, isSingleStatus = false, date }) => {
  const { status } = parameterStatusUtils.calculateStatus(
    value,
    range.min,
    range.max,
    date,
  );
  const simplifiedStatus = parameterStatusUtils.simplifyStatus(status);
  // For ParameterCard, treat warning as normal
  const displayStatus = isSingleStatus && simplifiedStatus === 'warning' ? 'normal' : simplifiedStatus;
  const color = parameterStatusUtils.getColorForSimpleStatus(displayStatus);
  
  // Use detailed status for Alto/Basso when isSingleStatus is true
  const label = isSingleStatus && status.startsWith('critical') 
    ? status === 'critical-high' ? 'Alto' : 'Basso'
    : parameterStatusUtils.getGenericLabelForSimpleStatus(displayStatus);

  return (
    <div className={`${color} px-2 py-1 rounded-md`}>
      <p className='text-sm font-medium'>{label}</p>
    </div>
  );
};

export const ParameterStatusDot: React.FC<{
  value: number;
  range: ParameterRange;
  date: string;
}> = ({ value, range, date }) => {
  const { status } = parameterStatusUtils.calculateStatus(
    value,
    range.min,
    range.max,
    date,
  );
  const simplifiedStatus = parameterStatusUtils.simplifyStatus(status);
  // Treat warning as normal for the dot
  const displayStatus = simplifiedStatus === 'warning' ? 'normal' : simplifiedStatus;
  const color = parameterStatusUtils.getColorForSimpleStatus(displayStatus);
  return <div className={`${color} w-3 h-3 rounded-full`} />;
};

// Helper to visualize parameter ranges
export const parameterRangeUtils = {
  getParameterZone: (
    value: number,
    thresholds: ReturnType<typeof parameterStatusUtils.getThresholdInfo>,
    date: string,
  ) => {
    const percentage =
      ((value - thresholds.criticalLow) /
        (thresholds.criticalHigh - thresholds.criticalLow)) *
      100;

    return {
      percentage,
      status: parameterStatusUtils.calculateStatus(
        value,
        thresholds.criticalLow,
        thresholds.criticalHigh,
        date,
      ),
      isInNormalRange:
        value >= thresholds.normalRange.min &&
        value <= thresholds.normalRange.max,
    };
  },
};
